module.exports = __webpack_public_path__ + "static/headshot-milan-shah.6fa54f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-milan-shah.jpg
// module id = 530
// module chunks = 152909308826437